export const RESET = "RESET";

// -- authenticate --
export const AUTHENTICATED = "AUTHENTICATED";
export const AUTHENTICATING = "AUTHENTICATING";
export const AUTHENTICATING_COMPLETED = "AUTHENTICATING_COMPLETED";
export const AUTHENTICATING_CANCELLED = "AUTHENTICATING_CANCELLED";
export const AUTHENTICATING_FAILED = "AUTHENTICATING_FAILED";
export const AUTHENTICATION_RESET = "AUTHENTICATION_RESET";

// --- rma ticket ---
export const TICKET_SEARCH_FETCHING = "TICKET_SEARCH_FETCHING";
export const TICKET_SEARCH_FETCHING_COMPLETED = "TICKET_SEARCH_FETCHING_COMPLETED";
export const TICKET_SEARCH_FETCHING_CANCELLED = "TICKET_SEARCH_FETCHING_CANCELLED";
export const TICKET_SEARCH_FETCHING_FAILED = "TICKET_SEARCH_FETCHING_FAILED";
export const TICKET_SEARCH_RESULT_LOAD = "TICKET_SEARCH_RESULT_LOAD";
export const TICKET_SEARCH_RESULT_RESET = "TICKET_SEARCH_RESULT_RESET";

export const TICKET_FETCHING = "TICKET_SEARCH_FETCHING";
export const TICKET_FETCHING_COMPLETED = "TICKET_SEARCH_FETCHING_COMPLETED";
export const TICKET_FETCHING_CANCELLED = "TICKET_FETCHING_CANCELLED";
export const TICKET_FETCHING_FAILED = "TICKET_SEARCH_FETCHING_FAILED";
export const TICKET_LOAD = "TICKET_SEARCH_RESULT_LOAD";
export const TICKET_RESET = "TICKET_SEARCH_RESULT_RESET";

export const TICKET_SEARCHING = "TICKET_SEARCHING";
export const TICKET_SEARCHING_COMPLETED = "TICKET_SEARCHING_COMPLETED";
export const TICKET_SEARCHING_CANCELLED = "TICKET_SEARCHING_CANCELLED";
export const TICKET_SEARCHING_FAILED = "TICKET_SEARCHING_FAILED";
export const TICKET_SEARCH_LOAD = "TICKET_SEARCH_LOAD";
export const TICKET_SEARCH_RESET = "TICKET_SEARCH_RESET";

export const RELATED_TICKET_FETCHING = "RELATED_TICKET_FETCHING";
export const RELATED_TICKET_FETCHING_COMPLETED = "RELATED_TICKET_FETCHING_COMPLETED";
export const RELATED_TICKET_FETCHING_CANCELLED = "RELATED_TICKET_FETCHING_CANCELLED";
export const RELATED_TICKET_FETCHING_FAILED = "RELATED_TICKET_FETCHING_FAILED";
export const RELATED_TICKET_RESULT_LOAD = "RELATED_TICKET_RESULT_LOAD";
export const RELATED_TICKET_RESULT_RESET = "RELATED_TICKET_RESULT_RESET";

export const TICKET_UPDATING = "TICKET_UPDATING";
export const TICKET_UPDATING_COMPLETED = "TICKET_UPDATING_COMPLETED";
export const TICKET_UPDATING_CANCELLED = "TICKET_UPDATING_CANCELLED";
export const TICKET_UPDATING_FAILED = "TICKET_UPDATING_FAILED";
export const TICKET_UPDATE_LOAD = "TICKET_UPDATE_LOAD";
export const TICKET_UPDATE_RESET = "TICKET_UPDATE_RESET";

export const TICKET_VALIDATING = "TICKET_VALIDATING";
export const TICKET_VALIDATING_COMPLETED = "TICKET_VALIDATING_COMPLETED";
export const TICKET_VALIDATING_CANCELLED = "TICKET_VALIDATING_CANCELLED";
export const TICKET_VALIDATING_FAILED = "TICKET_VALIDATING_FAILED";

export const RETURN_LABEL_FETCHING = "RETURN_LABEL_FETCHING";
export const RETURN_LABEL_FETCHING_COMPLETED = "RETURN_LABEL_FETCHING_COMPLETED";
export const RETURN_LABEL_FETCHING_FAILED = "RETURN_LABEL_FETCHING_FAILED";
export const RETURN_LABEL_FETCHING_CANCELLED = "RETURN_LABEL_FETCHING_CANCELLED";

// --- create RMA page
export const REFERENCE_ORDER_FETCHING = "REFERENCE_ORDER_FETCHING";
export const REFERENCE_ORDER_FETCHING_COMPLETED = "REFERENCE_ORDER_FETCHING_COMPLETED";
export const REFERENCE_ORDER_FETCHING_CANCELLED = "REFERENCE_ORDER_FETCHING_CANCELLED";
export const REFERENCE_ORDER_FETCHING_FAILED = "REFERENCE_ORDER_FETCHING_FAILED";
export const REFERENCE_ORDER_RESULT_LOAD = "REFERENCE_ORDER_RESULT_LOAD";
export const REFERENCE_ORDER_RESULT_RESET = "REFERENCE_ORDER_RESULT_RESET";

export const RETURN_ITEM_LIST_FETCHING = "RETURN_ITEM_LIST_FETCHING";
export const RETURN_ITEM_LIST_FETCHING_COMPLETED = "RETURN_ITEM_LIST_FETCHING_COMPLETED";
export const RETURN_ITEM_LIST_FETCHING_CANCELLED = "RETURN_ITEM_LIST_FETCHING_CANCELLED";
export const RETURN_ITEM_LIST_FETCHING_FAILED = "RETURN_ITEM_LIST_FETCHING_FAILED";
export const RETURN_ITEM_LIST_RESULT_LOAD = "RETURN_ITEM_LIST_RESULT_LOAD";
export const RETURN_ITEM_LIST_RESULT_RESET = "RETURN_ITEM_LIST_RESULT_RESET";

export const REPLACEMENT_ITEM_LIST_FETCHING = "REPLACEMENT_ITEM_LIST_FETCHING";
export const REPLACEMENT_ITEM_LIST_FETCHING_COMPLETED = "REPLACEMENT_ITEM_LIST_FETCHING_COMPLETED";
export const REPLACEMENT_ITEM_LIST_FETCHING_CANCELLED = "REPLACEMENT_ITEM_LIST_FETCHING_CANCELLED";
export const REPLACEMENT_ITEM_LIST_FETCHING_FAILED = "REPLACEMENT_ITEM_LIST_FETCHING_FAILED";
export const REPLACEMENT_ITEM_LIST_RESULT_LOAD = "REPLACEMENT_ITEM_LIST_RESULT_LOAD";
export const REPLACEMENT_ITEM_LIST_RESULT_RESET = "REPLACEMENT_ITEM_LIST_RESULT_RESET";

// --- zendesk ticket ---
export const ZENDESK_TICKET_FETCHING = "TICKET_SEARCH_FETCHING";
export const ZENDESK_TICKET_FETCHING_COMPLETED = "TICKET_SEARCH_FETCHING_COMPLETED";
export const ZENDESK_TICKET_FETCHING_CANCELLED = "TICKET_SEARCH_FETCHING_CANCELLED";
export const ZENDESK_TICKET_FETCHING_FAILED = "TICKET_SEARCH_FETCHING_FAILED";
export const ZENDESK_TICKET_LOAD = "ZENDESK_TICKET_LOAD";
export const ZENDESK_TICKET_RESET = "ZENDESK_TICKET_RESET";

// --- dimensions ---
export const LANGUAGE_LIST_FETCHING = "LANGUAGE_LIST_FETCHING";
export const LANGUAGE_LIST_FETCHING_COMPLETED = "LANGUAGE_LIST_FETCHING_COMPLETED";
export const LANGUAGE_LIST_FETCHING_CANCELLED = "LANGUAGE_LIST_FETCHING_CANCELLED";
export const LANGUAGE_LIST_FETCHING_FAILED = "LANGUAGE_LIST_FETCHING_FAILED";
export const LANGUAGE_LIST_LOAD = "LANGUAGE_LIST_LOAD";
export const LANGUAGE_LIST_RESET = "LANGUAGE_LIST_RESET";

export const REQUEST_TYPE_LIST_FETCHING = "REQUEST_TYPE_LIST_FETCHING";
export const REQUEST_TYPE_LIST_FETCHING_COMPLETED = "REQUEST_TYPE_LIST_FETCHING_COMPLETED";
export const REQUEST_TYPE_LIST_FETCHING_CANCELLED = "REQUEST_TYPE_LIST_FETCHING_CANCELLED";
export const REQUEST_TYPE_LIST_FETCHING_FAILED = "REQUEST_TYPE_LIST_FETCHING_FAILED";
export const REQUEST_TYPE_LIST_LOAD = "REQUEST_TYPE_LIST_LOAD";
export const REQUEST_TYPE_LIST_RESET = "REQUEST_TYPE_LIST_RESET";

export const REFERENCE_PLATFORM_LIST_FETCHING = "REFERENCE_PLATFORM_LIST_FETCHING";
export const REFERENCE_PLATFORM_LIST_FETCHING_COMPLETED = "REFERENCE_PLATFORM_LIST_FETCHING_COMPLETED";
export const REFERENCE_PLATFORM_LIST_FETCHING_CANCELLED = "REFERENCE_PLATFORM_LIST_FETCHING_CANCELLED";
export const REFERENCE_PLATFORM_LIST_FETCHING_FAILED = "REFERENCE_PLATFORM_LIST_FETCHING_FAILED";
export const REFERENCE_PLATFORM_LIST_LOAD = "REFERENCE_PLATFORM_LIST_LOAD";
export const REFERENCE_PLATFORM_LIST_RESET = "REFERENCE_PLATFORM_LIST_RESET";

export const RETURN_REASON_LIST_FETCHING = "RETURN_REASON_LIST_FETCHING";
export const RETURN_REASON_LIST_FETCHING_COMPLETED = "RETURN_REASON_LIST_FETCHING_COMPLETED";
export const RETURN_REASON_LIST_FETCHING_CANCELLED = "RETURN_REASON_LIST_FETCHING_CANCELLED";
export const RETURN_REASON_LIST_FETCHING_FAILED = "RETURN_REASON_LIST_FETCHING_FAILED";
export const RETURN_REASON_LIST_LOAD = "RETURN_REASON_LIST_LOAD";
export const RETURN_REASON_LIST_RESET = "RETURN_REASON_LIST_RESET";

export const REPLACEMENT_REASON_LIST_FETCHING = "REPLACEMENT_REASON_LIST_FETCHING";
export const REPLACEMENT_REASON_LIST_FETCHING_COMPLETED = "REPLACEMENT_REASON_LIST_FETCHING_COMPLETED";
export const REPLACEMENT_REASON_LIST_FETCHING_CANCELLED = "REPLACEMENT_REASON_LIST_FETCHING_CANCELLED";
export const REPLACEMENT_REASON_LIST_FETCHING_FAILED = "REPLACEMENT_REASON_LIST_FETCHING_FAILED";
export const REPLACEMENT_REASON_LIST_LOAD = "REPLACEMENT_REASON_LIST_LOAD";
export const REPLACEMENT_REASON_LIST_RESET = "REPLACEMENT_REASON_LIST_RESET";

export const COUNTRY_LIST_FETCHING = "COUNTRY_LIST_FETCHING";
export const COUNTRY_LIST_FETCHING_COMPLETED = "COUNTRY_LIST_FETCHING_COMPLETED";
export const COUNTRY_LIST_FETCHING_CANCELLED = "COUNTRY_LIST_FETCHING_V";
export const COUNTRY_LIST_FETCHING_FAILED = "COUNTRY_LIST_FETCHING_FAILED";
export const COUNTRY_LIST_LOAD = "COUNTRY_LIST_LOAD";
export const COUNTRY_LIST_RESET = "COUNTRY_LIST_RESET";

export const PROVINCE_LIST_FETCHING = "PROVINCE_LIST_FETCHING";
export const PROVINCE_LIST_FETCHING_COMPLETED = "PROVINCE_LIST_FETCHING_COMPLETED";
export const PROVINCE_LIST_FETCHING_CANCELLED = "PROVINCE_LIST_FETCHING_CANCELLED";
export const PROVINCE_LIST_FETCHING_FAILED = "PROVINCE_LIST_FETCHING_FAILED";
export const PROVINCE_LIST_LOAD = "PROVINCE_LIST_LOAD";
export const PROVINCE_LIST_RESET = "PROVINCE_LIST_RESET";

// --- misc ---
export const LANGUAGE_LOAD = "LANGUAGE_LOAD";
export const LANGUAGE_RESET = "LANGUAGE_RESET";

export const AUTH_TOKEN_FETCHING = "AUTH_TOKEN_FETCHING";
export const AUTH_TOKEN_FETCHING_COMPLETED = "AUTH_TOKEN_FETCHING_COMPLETED";
export const AUTH_TOKEN_FETCHING_CANCELLED = "AUTH_TOKEN_FETCHING_CANCELLED";
export const AUTH_TOKEN_FETCHING_FAILED = "AUTH_TOKEN_FETCHING_FAILED";
export const AUTH_TOKEN_LOAD = "AUTH_TOKEN_LOAD";
export const AUTH_TOKEN_RESET = "AUTH_TOKEN_RESET";

export const TICKET_VERIFYING = "TICKET_VERIFYING";
export const TICKET_VERIFYING_COMPLETED = "TICKET_VERIFYING_COMPLETED";
export const TICKET_VERIFYING_CANCELLED = "TICKET_VERIFYING_CANCELLED";
export const TICKET_VERIFYING_FAILED = "TICKET_VERIFYING_FAILED";

export const TICKET_VERIFY_DATA_LOAD = "TICKET_VERIFY_DATA_LOAD";
export const TICKET_VERIFY_DATA_RESET = "TICKET_VERIFY_DATA_RESET";

// export const COUNTRY_LIST_FETCHING = "COUNTRY_LIST_FETCHING";
// export const COUNTRY_LIST_FETCHING_COMPLETED = "COUNTRY_LIST_FETCHING_COMPLETED";
// export const COUNTRY_LIST_FETCHING_FAILED = "COUNTRY_LIST_FETCHING_FAILED";
// export const COUNTRY_LIST_LOAD = "COUNTRY_LIST_LOAD";
// export const COUNTRY_LIST_RESET = "COUNTRY_LIST_RESET";

// export const PROVINCE_LIST_FETCHING = "PROVINCE_LIST_FETCHING";
// export const PROVINCE_LIST_FETCHING_COMPLETED = "PROVINCE_LIST_FETCHING_COMPLETED";
// export const PROVINCE_LIST_FETCHING_FAILED = "PROVINCE_LIST_FETCHING_FAILED";
// export const PROVINCE_LIST_LOAD = "PROVINCE_LIST_LOAD";
// export const PROVINCE_LIST_RESET = "PROVINCE_LIST_RESET";
